import styles from "./FormController.module.scss";
import Button from "@/components/Button";
import { CircularProgress } from "@/components/Loader";
import { MouseEventHandler } from "react";
import cx from "classnames";

const FormActions: React.FC<{
  secondaryButton?: {
    label?: string;
    action?: MouseEventHandler<HTMLButtonElement> | undefined;
    isDisabled?: boolean;
    className?: string;
  };
  primaryButton?: {
    label?: string;
    loadingLabel?: string;
    action?: MouseEventHandler<HTMLButtonElement> | undefined;
    isLoading?: boolean;
    isDisabled?: boolean;
    className?: string;
  };
  isDialogAction?: boolean;
}> = ({ primaryButton, secondaryButton, isDialogAction }) => {
  return (
    <div
      className={cx(styles.actions, { [styles.dialogAction]: isDialogAction })}
    >
      {Boolean(secondaryButton?.label?.length) && (
        <Button
          variant="outlined"
          color="info"
          onClick={secondaryButton?.action}
          disabled={primaryButton?.isLoading || secondaryButton?.isDisabled}
          className={cx(
            styles.secondaryActionButton,
            styles.secondaryActionButtonMotion,
            secondaryButton?.className
          )}
        >
          {secondaryButton?.label}
        </Button>
      )}
      <Button
        onClick={primaryButton?.action}
        disabled={primaryButton?.isLoading || primaryButton?.isDisabled}
        startIcon={
          primaryButton?.isLoading && <CircularProgress color="inherit" />
        }
        className={cx(
          styles.primaryActionButtonMotion,
          primaryButton?.className
        )}
      >
        {primaryButton?.isLoading
          ? primaryButton?.loadingLabel || "Saving..."
          : primaryButton?.label}
      </Button>
    </div>
  );
};

export default FormActions;
